export default __webpack_public_path__ + "static/media/resource-inventory-annie-theby-min.665bd9f8.jpg";